/*
*                                 .i;;;;i.
*                               iYcviii;vXY:
*                             .YXi       .i1c.
*                            .YC.     .    in7.
*                           .vc.   ......   ;1c.
*                           i7,   ..        .;1;
*                          i7,   .. ...      .Y1i
*                         ,7v     .6MMM@;     .YX,
*                        .7;.   ..IMMMMMM1     :t7.
*                       .;Y.     ;$MMMMMM9.     :tc.
*                       vY.   .. .nMMM@MMU.      ;1v.
*                      i7i   ...  .#MM@M@C. .....:71i
*                     it:   ....   $MMM@9;.,i;;;i,;tti
*                    :t7.  .....   0MMMWv.,iii:::,,;St.
*                   .nC.   .....   IMMMQ..,::::::,.,czX.
*                  .ct:   ....... .ZMMMI..,:::::::,,:76Y.
*                  c2:   ......,i..Y$M@t..:::::::,,..inZY
*                 vov   ......:ii..c$MBc..,,,,,,,,,,..iI9i
*                i9Y   ......iii:..7@MA,..,,,,,,,,,....;AA:
*               iIS.  ......:ii::..;@MI....,............;Ez.
*              .I9.  ......:i::::...8M1..................C0z.
*             .z9;  ......:i::::,.. .i:...................zWX.
*             vbv  ......,i::::,,.      ................. :AQY
*            c6Y.  .,...,::::,,..:t0@@QY. ................ :8bi
*           :6S. ..,,...,:::,,,..EMMMMMMI. ............... .;bZ,
*          :6o,  .,,,,..:::,,,..i#MMMMMM#v.................  YW2.
*         .n8i ..,,,,,,,::,,,,.. tMMMMM@C:.................. .1Wn
*         7Uc. .:::,,,,,::,,,,..   i1t;,..................... .UEi
*         7C...::::::::::::,,,,..        ....................  vSi.
*         ;1;...,,::::::,.........       ..................    Yz:
*          v97,.........                                     .voC.
*           izAotX7777777777777777777777777777777777777777Y7n92:
*             .;CoIIIIIUAA666666699999ZZZZZZZZZZZZZZZZZZZZ6ov.
*
*
*  WARNING: Do not install this util without talking with the UI Dev Leadership: MCOMUIDevLeadership@Macys.com
*  This util has not been proven production ready yet and is still under development.
*
 */

const dateFormat = require('dateformat');
const formatter = require('../server-logger/formatter');

// Push logger Props onto the window object if available to prevent disconnect with multiple copies of @core/util
// in the dependency tree.
const loggerProps = {
  get: (key) => {
    if (typeof window !== 'undefined') {
      return window.__UNIVERSAL_LOGGER_PROPS__[key];
    }

    return loggerProps[key];
  },
  set: (key, value) => {
    if (!Object.hasOwnProperty.call(loggerProps, key)) {
      throw new Error(`Invalid key: ${key}`);
    }
    if (typeof window !== 'undefined') {
      window.__UNIVERSAL_LOGGER_PROPS__[key] = value;
    }

    loggerProps[key] = value;
  },
  appEnv: process.env.APP_ENV || 'server',
  ssLogger: undefined,
  ssProps: undefined,
  logLevel: undefined,
  logUri: undefined,
  recordClientLogs: false,
};

if (typeof window !== 'undefined' && typeof window.__UNIVERSAL_LOGGER_PROPS__ === 'undefined') {
  window.__UNIVERSAL_LOGGER_PROPS__ = loggerProps;
}

// Values used to determine if the request meets the current logging level requirement
const levelValues = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

/**
 * Process an argument passed to the logger and return message and stack trace if available.
 * Designed to handle the passing of strings, objects, and errors to the logger.
 *
 * @param arg
 * @returns {{message: *, stack: *}}
 */
function processArgument(arg) {
  let message;
  let stack;
  let preformatted;
  let filename;

  if (typeof arg === 'object') {
    if (arg.message) {
      if (arg.stack) {
        stack = arg.stack.replace(/\n/g, ';');
      }
      if (arg.filename) {
        filename = arg.filename;
      }
      message = arg.message;
    } else if (arg.preformatted) {
      preformatted = arg.preformatted;
    } else {
      message = JSON.stringify(arg);
    }
  } else {
    message = arg;
  }

  return {
    message, stack, preformatted, filename,
  };
}

/**
 * This method actually logs.
 *
 * @param method - debug, info, warn or error
 * @param args - strings/objects combined to generate the message and stack trace
 */
function log(method, ...args) {
  if (!Object.hasOwnProperty.call(levelValues, method)) {
    throw new Error('First parameter for the logger method must be debug/info/warn/error');
  }

  if (loggerProps.get('appEnv') === 'client') {
    const clientLogger = require('../clientlogger');
    // Send message to the client logger that will print to console based on environment
    clientLogger[method](...args);

    // Only call recording logic if initialized.
    if (loggerProps.get('recordClientLogs')) {
    // Default to error level
      const applicationLogLevel = loggerProps.get('logLevel') || 'error';
      if (levelValues[method] >= levelValues[applicationLogLevel]) {
      // Default to unknown application name
        let applicationName = 'unknown';

        // Try to set application name based on Webpack define plugin replacement of WEBPACK.POLARIS_APPLICATION_NAME
        try {
          applicationName = WEBPACK.POLARIS_APPLICATION_NAME; // eslint-disable-line no-undef
        } catch (e) {
          console.warn('Could not determine application name.');
        }

        // Try to post log message to remote collector
        try {
        // Validate that a uri has been defined for sending log message to remote collector
          if (typeof loggerProps.get('logUri') === 'undefined' || loggerProps.get('logUri') === null) {
            throw new Error('No log uri defined.  Not sending log to remote collector.');
          }

          let stackTrace;
          const errorMessage = [];

          // Get message and stack trace
          args.forEach((arg) => {
            const { message, stack } = processArgument(arg);
            if (message) {
              errorMessage.push(message);
            }
            if (stack) {
              stackTrace = stack;
            }
          });

          const cookies = document.cookie.split('; ').reduce((prev, current) => {
            const [name, value] = current.split('=');
            prev[name] = value;
            return prev;
          }, {});

          // Format the message as requested by SST
          const { message } = formatter({
            timestamp: dateFormat(new Date(), 'ddd mmm dd HH:MM:ss Z yyyy', true),
            level: method,
            cookies,
            name: applicationName,
            file: `Client-side Application: ${document.location.href.replace('|', encodeURI('|'))}`,
            message: errorMessage.join(' ') || null,
            exception: stackTrace || 'NO_EXCEPTION',
          });

          const xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                clientLogger.log(xhr.responseText); // 'This is the returned text.'
              } else {
                clientLogger.error(`Failed sending log message to collector: ${xhr.status}`); // An error occurred during the request.
              }
            }
          };

          // Convert Pipe delimeted log message format to JSON for RASM ingestion
          const messageJSON = Object.assign(...message.split('|').map((pair) => {
            const arr = pair.split('=');
            const obj = {};
            obj[arr[0]] = arr[1] || '';
            return obj;
          }));
          clientLogger.info(`Posting the following to RASM endpoint ${loggerProps.get('logUri')} -  ${JSON.stringify(messageJSON)}`);

          xhr.open('POST', loggerProps.get('logUri'));
          xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
          xhr.send(JSON.stringify(messageJSON));
        } catch (e) {
          clientLogger.error(e);
        }
      }
    }
  } else if (loggerProps.get('ssLogger')) {
    // Default to error level
    const applicationLogLevel = process.env.LOG_LEVEL || 'error';
    if (levelValues[method] >= levelValues[applicationLogLevel]) {
      // If we have more than one argument pop the first off the array and make it the request
      // There may not be a request object passed.
      const req = args.length > 1 ? args.shift() : {};

      let errorMessage = 'No message';
      let stackTrace = 'No stack trace available';

      const {
        message, stack, preformatted, filename,
      } = processArgument(args[0]);

      if (message) {
        errorMessage = message;
      }
      if (stack) {
        stackTrace = stack;
      }

      const output = {
        preformatted, file: filename, name: loggerProps.ssProps.name, version: loggerProps.ssProps.version, timestamp: dateFormat(new Date(), 'ddd mmm dd HH:MM:ss Z yyyy', true), level: (method === 'warn') ? 'warning' : method, message: errorMessage, cookies: Object.assign({}, req.cookies), headers: Object.assign({}, req.headers), exception: stackTrace,
      };

      loggerProps.get('ssLogger').log(output);
    }
  } else {
    throw new Error('Server-side logger not assigned');
  }
}


function setupServerLogger(ssLogger, props) {
  loggerProps.set('ssLogger', ssLogger);
  loggerProps.set('ssProps', props);
}


/**
 * This method is used to initialize the client-side logger with the run-time value of
 * log level as well as the ability to override the default destination for POSTs.
 *
 * It also attaches listeners to the window to log any errors
 *
 * @param options - Object with optional keys: logLevel and logUri
 */
function initClientLogRecording(options = {}) {
  loggerProps.set('recordClientLogs', true);
  const opts = Object.assign({ logLevel: 'error', logUri: 'https://metrics-dev.macys.net/stream' }, options);
  if (Object.hasOwnProperty.call(levelValues, opts.logLevel)) {
    loggerProps.set('logLevel', opts.logLevel);
  } else {
    throw new Error(`'${opts.logLevel}' is not a valid log level.`);
  }
  loggerProps.set('logUri', opts.logUri);

  // Listen for any errors and pass them to the logger.
  // Handle event object with error child or error object passed directly.
  window.addEventListener('error', (e) => { log('error', e.error || e); });
  // Handle bad promise code which is a unique event
  window.addEventListener('unhandledrejection', (e) => { log('error', e.reason); });
}

function error(...args) {
  return log('error', ...args);
}

function warn(...args) {
  return log('warn', ...args);
}

function info(...args) {
  return log('info', ...args);
}

function debug(...args) {
  return log('debug', ...args);
}

/*
 * Following functions are only available in the client-side logger so their functionality ir wrapped in a
 * client-side check.
 */

function dir(...args) {
  if (loggerProps.get('appEnv') === 'client') {
    return log('dir', ...args);
  }

  return null;
}

function time(...args) {
  if (loggerProps.get('appEnv') === 'client') {
    return log('time', ...args);
  }

  return null;
}

function timeEnd(...args) {
  if (loggerProps.get('appEnv') === 'client') {
    return log('timeEnd', ...args);
  }

  return null;
}


module.exports = {
  log,
  error,
  warn,
  info,
  debug,
  dir,
  time,
  timeEnd,
  setupServerLogger,
  initClientLogRecording,
};
